import RequestUtils from "utils/RequestUtils";
import HotelRes from "types/res/hotel/HotelRes";

export default class HotelApi {
  static async fetchHotel(companyId: number) {
    return await RequestUtils.getArray(HotelRes, `/hotel/findAll/${companyId}`);
  }
}
